import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { navigationPaths } from "../../constants/paths"
import ApplicationLayout from "../../layouts/ApplicationLayout"
import BasicVehicleList from "../../components/vehicles/BasicVehicleList"
import { Grid, Modal } from "semantic-ui-react"
import Select from "../../elements/Select"
import { Header, Segment, Button, Input, Checkbox as SematicCheckbox } from "semantic-ui-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight } from "@fortawesome/pro-light-svg-icons"
import * as fleetHelpers from "../../helpers/fleetHelpers"
import * as vehicleHelpers from "../../helpers/vehicleHelpers"
import { withTranslation } from "react-i18next"
import Alert, { ALERT_MESSAGE } from "../../components/shared/Alert"
import { isFmcPath } from "../../helpers/pathHelpers"
import { isFMCUser } from "../../helpers/userRoleHelpers"
import { FLEET, FILTER_OPTIONS, VIN, EVENTS } from "../../constants/application"
import { isFleetAdvise, isMobilease } from "../../helpers/affiliationHelpers"
import CustomNotification from "../../components/shared/CustomNotification"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import { debounce } from "lodash"
import { logFirebaseAnalyticsScreenName } from "../../helpers/googleAnalyticsHelpers"
import { getRouteNameFromUrl } from "../../helpers/segmentHelpers"
import { clearStateAfterTimeout } from "../../helpers/documentHelpers"
import { faArrowRightLong } from "@fortawesome/pro-regular-svg-icons"

class TransferVehicles extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fleet_id_1: null,
      fleet_id_2: null,
      vehicle_id: null,
      vehicles1: [],
      vehicles2: [],
      searchVehicles: [],
      section: 0,
      selectedRows: [],
      alertMessage: "",
      alertType: "default",
      showGrid1: true,
      showGrid2: true,
      disabled: true,
      showDropdown: false,
      selectedOption: VIN,
      search_text: "",
      withSearch: false,
      showTransferConfirmModal: false
    }
    this.debounceSearch = debounce(this.onSearch, 1000)
  }

  componentDidMount() {
    logFirebaseAnalyticsScreenName(getRouteNameFromUrl())

    this.loadAllFleets()
    this.loadBasicVehicles()
  }

  componentWillUnmount() {
    this.debounceSearch.cancel()
  }

  setShowTransferConfirmModal(showTransferConfirmModal) {
    this.setState({ showTransferConfirmModal: showTransferConfirmModal })
  }

  loadFleetWiseVehicles = async (fleet_id, section) => {
    await this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: {
        options: {
          fleet_id: fleet_id
        }
      },
      callback: this.afterloadFleetWiseVehiclesSuccess
    })
  }

  loadVehicle = async (vehicle_id) => {
    const { vehicleId } = this.state

    this.props.dispatch({
      type: "VEHICLE_LOAD_SAGA",
      payload: {
        vehicleId: parseInt(vehicle_id),
        options: {
          search: true
        }
      },
      callback: this.afterloadVehicleSuccess
    })
  }

  loadBasicVehicles = async () => {
    await this.props.dispatch({
      type: "VEHICLES_BASIC_LOAD_SAGA",
      payload: {}
    })
  }

  loadAllFleets = () => {
    this.props.dispatch({
      type: "ALL_FLEETS_LOAD_SAGA",
      payload: {}
    })
  }

  transferVehicles = (vehicle_ids, old_fleet_ids, new_fleet_id) => {
    return new Promise((resolve, reject) => {
      this.props.dispatch({
        type: "VEHICLE_TRANSFER_SAGA",
        payload: {
          options: {
            vehicle_ids: vehicle_ids,
            old_fleet_ids: old_fleet_ids,
            new_fleet_id: new_fleet_id
          }
        },
        callback: (response) => {
          this.afterTransferVehiclesSuccess(response)
          resolve(response)
        }
      })
    })
  }

  afterloadFleetWiseVehiclesSuccess = (response) => {
    const { section, withSearch } = this.state
    let sortedResponse = Array.isArray(response)
      ? response.slice().sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
      : response
    if (section == 1) {
      this.setState({
        vehicles1: withSearch ? sortedResponse.vehicles : sortedResponse,
        showGrid1: true
      })
    } else if (section == 2) {
      this.setState({
        withSearch: false,
        search_text: "",
        vehicles2: sortedResponse,
        showGrid2: true
      })
    }

    this.setState({ showDropdown: false })
  }

  afterloadVehicleSuccess = (response) => {
    let tempArray = []
    tempArray = [...tempArray, response]
    this.setState({ vehicles1: tempArray, showGrid1: true })
  }

  afterTransferVehiclesSuccess = (response) => {
    const { t } = this.props
    this.setState({
      alertMessage: t("transferSuccessMsg"),
      alertType: isFleetAdvise() || isMobilease() ? "success" : "notice"
    })
  }

  onFleet1Change = (fleet_id) => {
    const { t } = this.props
    const { fleet_id_2 } = this.state

    if (fleet_id_2 == fleet_id) {
      this.setState({
        alertMessage: t("sameFleetSelectMsg"),
        alertType: "error"
      })
    } else if (fleet_id == "") {
      this.setState({
        fleet_id_1: null,
        vehicles1: [],
        vehicle_id: null,
        disabled: true,
        selectedRows: [],
        section: 0,
        searchVehicles: []
      })
    } else {
      this.setState({
        fleet_id_1: fleet_id,
        section: 1,
        vehicle_id: null,
        alertMessage: "",
        showGrid1: false,
        search_text: ""
      })
      this.loadFleetWiseVehicles(fleet_id, 1)
    }
  }

  onFleet2Change = (fleet_id) => {
    const { t } = this.props
    const { fleet_id_1 } = this.state

    if (fleet_id_1 == fleet_id) {
      this.setState({
        alertMessage: t("sameFleetSelectMsg"),
        alertType: "error"
      })
    } else if (fleet_id == "") {
      this.setState({
        fleet_id_2: null,
        vehicles2: [],
        vehicle_id: null,
        disabled: true,
        selectedRows: [],
        section: 0,
        searchVehicles: []
      })
    } else {
      this.setState({
        fleet_id_2: fleet_id,
        section: 2,
        alertMessage: "",
        showGrid2: false
      })
      this.loadFleetWiseVehicles(fleet_id, 2)
    }
  }

  onVehicleChange = (vehicle_id) => {
    this.setState({ vehicle_id: vehicle_id, fleet_id_1: null, alertMessage: "", showGrid1: false })
    this.loadVehicle(vehicle_id)
  }

  swapVehicles = () => {
    const { t } = this.props
    const { selectedRows, vehicles1, fleet_id_2, fleet_id_1 } = this.state
    if (selectedRows.length == 0 || (!fleet_id_2 && !fleet_id_1))
      this.setState({ alertMessage: t("missingFleetMsg"), alertType: "error" })
    else if (!fleet_id_2)
      this.setState({
        alertMessage: t("DestinationFLeetMissingMsg"),
        alertType: "error"
      })
    else {
      let result = []
      selectedRows.map((row) => result.push(row["data"]))
      let array1 = vehicles1.filter((ar) => !result.find((rm) => rm.id === ar.id))

      this.setState(
        (prevState) => {
          return {
            vehicles2: [...result, ...prevState.vehicles2],
            vehicles1: array1,
            disabled: false
          }
        },
        () => {
          this.saveVehicles()
        }
      )
    }
  }

  onSelectionChanged = (event) => {
    this.setState({ selectedRows: event.api.getSelectedNodes() })
  }

  saveVehicles = () => {
    const { vehicles2, fleet_id_2 } = this.state
    let result = vehicles2.map((entry) => {
      return entry.id
    })

    let old_fleet_ids = vehicles2.map((entry) => {
      return entry.fleet_id
    })

    this.transferVehicles(result, old_fleet_ids, fleet_id_2).then(() => {
      this.loadFleetWiseVehicles(fleet_id_2, 2)
    })
  }

  refresh = () => {
    this.setState({
      vehicles1: [],
      vehicles2: [],
      vehicle_id: null,
      searchVehicles: [],
      section: 0,
      selectedRows: [],
      fleet_id_1: null,
      fleet_id_2: null,
      disabled: true,
      alertMessage: "",
      search_text: "",
      withSearch: false
    })
  }

  handleInputClick = (e) => {
    this.setState({ showDropdown: true })
  }

  onTextChange = (event) => {
    this.setState({
      search_text: event.target.value,
      section: 1,
      withSearch: true,
      fleet_id_1: null
    })
    this.debounceSearch(event.target.value)
  }

  loadAllVehicles = async (payload) => {
    await this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA",
      payload: payload,
      callback: this.afterloadFleetWiseVehiclesSuccess
    })
  }

  handleKeyDown = (event) => {
    if (event.key === EVENTS.ENTER) {
      this.onSearch()
    }
  }

  onSearch = () => {
    const { t } = this.props
    const { search_text, selectedOption, showDropdown } = this.state
    if (search_text !== "" && search_text.length >= 3) {
      this.loadAllVehicles({ page: 1, query: search_text, search_type: selectedOption, fmc: true })
    } else if (search_text == "") {
      this.setState({ vehicles1: [], withSearch: false, showDropdown: false })
    } else {
      return CustomNotification(NOTIFICATION_TYPE.DANGER, "", t("invalidSearchValue"), t)
    }
  }

  handleOptionChange = (e) => {
    this.setState({ selectedOption: e.target.value })
  }

  render() {
    const { users, dispatch, fleets, t, basicVehicles, currentUser, fleet, language } = this.props
    const {
      fleet_id_1,
      fleet_id_2,
      vehicles1,
      vehicles2,
      vehicle_id,
      alertType,
      alertMessage,
      showGrid1,
      showGrid2,
      disabled,
      showTransferConfirmModal,
      selectedRows
    } = this.state

    return (
      <ApplicationLayout>
        {alertMessage ? (
          <Alert
            message={alertMessage}
            type={alertType}
            t={t}
            clearStateAfterTimeout={() =>
              clearStateAfterTimeout(this.setState.bind(this), ALERT_MESSAGE)
            }
          />
        ) : (
          ""
        )}
        <Modal
          closeIcon
          onClose={() => this.setShowTransferConfirmModal(false)}
          onOpen={() => this.setShowTransferConfirmModal(true)}
          open={showTransferConfirmModal}
          size="mini"
        >
          <Modal.Header>Confirm vehicle transfer?</Modal.Header>
          <Modal.Actions>
            <Button
              color="green"
              active={true}
              onClick={() => {
                this.swapVehicles()
                this.setShowTransferConfirmModal(false)
              }}
            >
              Yes
            </Button>
            <Button
              color="red"
              active={true}
              onClick={() => {
                this.setShowTransferConfirmModal(false)
              }}
            >
              No
            </Button>
          </Modal.Actions>
        </Modal>
        <div className="mt-5">
          <Grid columns="equal" stackable className="mt-10">
            <Grid.Column width={7} style={{ position: "inherit", alignSelf: "end" }}>
              <Header size="small" className={"dash-hd"}>
                {t("transferVehicles")}
              </Header>
              <Header size="small" className={"dash-hd"}>
                {t("sourceFleet")}
              </Header>
            </Grid.Column>

            <Grid.Column width={2}></Grid.Column>

            <Grid.Column width={7}>
              <Grid columns="equal" stackable>
                <Grid.Column width={8}>
                  <Header size="small" className={"dash-hd"}>
                    {t("destinationFleet")}
                  </Header>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>

          <Grid columns="equal" stackable>
            <Grid.Column width={7}>
              <Segment className={"ag-theme-material"}>
                <Grid columns="equal" stackable>
                  <Grid.Column width={7}>
                    {basicVehicles.length > 0 ? (
                      <div className="search-input-parent">
                        <div className="search-input-box-vin">
                          <Input
                            className="search search-fleet"
                            icon="search"
                            value={this.state.search_text}
                            onClick={this.handleInputClick}
                            onChange={this.onTextChange}
                            placeholder={t("SearchVehicleLabel")}
                            onKeyDown={this.handleKeyDown}
                          />
                          {this.state.showDropdown && (
                            <div className="filter-options-parent vin-filter" ref={this.wrapperRef}>
                              <p>{t("iAmLookingForLabel")}</p>
                              <div className="filter-options">
                                {FILTER_OPTIONS.map((option) => (
                                  <label key={option.value}>
                                    <input
                                      type="radio"
                                      value={option.value}
                                      checked={option.value === this.state.selectedOption}
                                      onChange={this.handleOptionChange}
                                      className={
                                        isFleetAdvise() || isMobilease() ? "radio-btn-color" : ""
                                      }
                                    />
                                    {option.key}
                                    <br />
                                  </label>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Grid.Column>
                  <Grid.Column width={2} className="text-style">
                    {t("or")}
                  </Grid.Column>
                  <Grid.Column width={7}>
                    {fleets.length > 0 ? (
                      <Select
                        onChange={(event) => this.onFleet1Change(event.target.value)}
                        options={fleetHelpers.selectOptions(fleets)}
                        placeholder={t("seachByFleet")}
                        defaultValue={fleet_id_1}
                        value={fleet_id_1}
                      />
                    ) : (
                      ""
                    )}
                  </Grid.Column>
                </Grid>
              </Segment>
            </Grid.Column>

            <Grid.Column width={2}></Grid.Column>

            <Grid.Column width={7}>
              <Segment className={"ag-theme-material"}>
                <Grid columns="equal" stackable>
                  <Grid.Column width={7}></Grid.Column>
                  <Grid.Column width={2} className="text-style"></Grid.Column>
                  <Grid.Column width={7}>
                    {fleets.length > 0 ? (
                      <Select
                        onChange={(event) => this.onFleet2Change(event.target.value)}
                        options={fleetHelpers.selectOptions(fleets)}
                        placeholder={t("seachByFleet")}
                        defaultValue={fleet_id_2}
                        value={fleet_id_2}
                      />
                    ) : (
                      ""
                    )}
                  </Grid.Column>
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid>

          <Grid columns="equal" stackable>
            <Grid.Column width={7}>
              <BasicVehicleList
                users={users}
                vehicles={vehicles1}
                loadVehicles={this.componentDidMount.bind(this)}
                onDeleteVehicle={this.onDeleteVehicle}
                onDeactivateVehicle={this.onDeactivateVehicle}
                language={language}
                dispatch={dispatch}
                currentUser={currentUser}
                showMultiSelection={true}
                onSelectionChanged={this.onSelectionChanged}
                showGrid1={showGrid1}
                emptyListLabel={
                  fleet_id_1 || this.state.search_text
                    ? t("noVehiclesInFleetLabel")
                    : t("pleaseSearchForAVehicleOrFleet")
                }
              />
            </Grid.Column>
            <Grid.Column width={2} style={{ margin: "auto", textAlign: "center" }}>
              <FontAwesomeIcon icon={faArrowRightLong} size="5x" />
              <p />
              <Button
                secondary
                content={t("transferVehicles")}
                onClick={() => {
                  this.setShowTransferConfirmModal(true)
                }}
                disabled={selectedRows.length === 0 || !fleet_id_2}
                size="tiny"
              />
              <p />
              <Button secondary content="Reset" onClick={() => this.refresh()} size="tiny" />
            </Grid.Column>
            <Grid.Column width={7}>
              <BasicVehicleList
                users={users}
                vehicles={vehicles2}
                loadVehicles={this.componentDidMount.bind(this)}
                onDeleteVehicle={this.onDeleteVehicle}
                onDeactivateVehicle={this.onDeactivateVehicle}
                language={language}
                dispatch={dispatch}
                currentUser={currentUser}
                showMultiSelection={false}
                showGrid2={showGrid2}
                emptyListLabel={fleet_id_2 ? t("noVehiclesInFleetLabel") : t("pleaseSelectAFleet")}
              />
            </Grid.Column>
          </Grid>
        </div>
      </ApplicationLayout>
    )
  }
} // class TransferVehicle

const mapStateToProps = (state, props) => {
  const { users } = state
  const user = state.application.userSessionData || (users && users.currentUser)
  const isFMC = isFMCUser(user)
  const isPathFMC = isFmcPath()
  return {
    isFleetMode: state.application.mode === FLEET || (isFMC && !isPathFMC),
    users: state.users.users,
    vehicles1: state.vehicles.vehicles1,
    vehicles2: state.vehicles.vehicles2,
    basicVehicles: state.vehicles.basicVehicles,
    vehicle: state.vehicles.vehicle,
    fleet: state.application.fleetSessionData || state.fleets.fleet,
    language:
      (state.application.userSessionData && state.application.userSessionData.language) ||
      (state.users.currentUser && state.users.currentUser.language),
    currentUser: user,
    fleets: state.fleets.all_fleets
  }
}

export default connect(mapStateToProps, null)(withTranslation("vehicleIndex")(TransferVehicles))
